module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit_wrap"
  }, [_c('div', {
    staticClass: "add_top"
  }, [_c('div', {
    staticClass: "add_tab active_tab",
    on: {
      "click": _vm.choiceTab
    }
  }, [_vm._v("申请大V店已有品牌")]), _vm._v(" "), _c('div', {
    staticClass: "add_tab",
    on: {
      "click": _vm.addTab
    }
  }, [_vm._v("添加新品牌")])]), _vm._v(" "), (_vm.status == 9) ? _c('p', {
    staticClass: "main_word mt20",
    attrs: {
      "align": "center"
    }
  }, [_vm._v("图书类复审驳回后不能修改品牌信息")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isChoice),
      expression: "isChoice"
    }],
    staticClass: "choice_brand"
  }, [(_vm.status != 9) ? _c('div', {
    staticClass: "add_search mt20 clearfix"
  }, [_c('el-button', {
    staticClass: "r ml10 mr20",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.keySearch
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-input', {
    staticClass: "w325 r",
    attrs: {
      "placeholder": "输入品牌名称关键字，搜索大V店是否已有该品牌"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.keySearch($event)
      }
    },
    model: {
      value: (_vm.brand_key),
      callback: function($$v) {
        _vm.brand_key = $$v
      },
      expression: "brand_key"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "add_name mt20"
  }, [_c('div', {
    staticClass: "c_name"
  }, [_c('span', {
    staticClass: "main_word mr4"
  }, [_vm._v("*")]), _vm._v("\n\t\t\t\t\t品牌中文名称：\n\t\t\t\t\t"), (!_vm.alSelect) ? _c('span', {
    staticClass: "main_word f12"
  }, [_vm._v("根据您选择搜索到的大V店已有品牌，系统自动填充中文名称")]) : _c('span', [_vm._v(_vm._s(_vm.brandName))])]), _vm._v(" "), _c('div', {
    staticClass: "e_name mt20"
  }, [_c('span', {
    staticClass: "main_word mr4"
  }, [_vm._v("*")]), _vm._v("\n\t\t\t\t\t品牌英文名称：\n\t\t\t\t\t"), (!_vm.alSelect) ? _c('span', {
    staticClass: "main_word f12"
  }, [_vm._v("根据您选择搜索到的大V店已有品牌，系统自动填充英文名称")]) : _c('span', [_vm._v(_vm._s(_vm.brandEnname))])]), _vm._v(" "), _c('p', {
    staticClass: "f14 f666 mt20"
  }, [_vm._v("如果没有找到你要申请的品牌，请添加品牌信息，审核通过后会将品牌信息录入大V店品牌库。")])]), _vm._v(" "), _c('div', {
    staticClass: "w150 auto mt120"
  }, [(_vm.status != 9) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.status == 9) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.status == 9,
      "type": "primary"
    },
    on: {
      "click": _vm.save_choice
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.search_result,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.search_result = $event
      }
    }
  }, [_c('div', {
    staticClass: "wp100 tc"
  }, [_vm._v("搜索结果如下，若没有您要的品牌，请【添加新品牌】")]), _vm._v(" "), _c('div', {
    staticClass: "mt20"
  }, [_c('el-radio-group', {
    staticClass: "radio_group",
    on: {
      "change": _vm.change_select
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, _vm._l((_vm.list), function(val) {
    return _c('el-radio', {
      key: val.brandId,
      staticClass: "list_radio",
      attrs: {
        "label": val.brandId
      }
    }, [_vm._v(_vm._s(val.brandName))])
  }))], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.search_result = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.noSelect,
      "type": "primary"
    },
    on: {
      "click": _vm.sure_select
    }
  }, [_vm._v("确 定")])], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isChoice),
      expression: "!isChoice"
    }],
    staticClass: "add_brand mt20"
  }, [_c('el-form', {
    ref: "addForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.addForm,
      "rules": _vm.rules,
      "label-width": "200px"
    }
  }, [_c('span', {
    staticClass: "ml90 f999"
  }, [_vm._v("如果【申请大V店已有品牌】功能没有找到您要经营的品牌，请添加品牌信息，审核通过后会将品牌信息录入大V店品牌库：")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt10",
    attrs: {
      "label": "品牌中文名称：",
      "prop": "brandName"
    }
  }, [_c('el-input', {
    staticClass: "w250",
    attrs: {
      "disabled": _vm.status == 9,
      "placeholder": "请输入品牌中文名称"
    },
    model: {
      value: (_vm.addForm.brandName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "brandName", $$v)
      },
      expression: "addForm.brandName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌英文名称：",
      "prop": "brandEnname"
    }
  }, [_c('el-input', {
    staticClass: "w250",
    attrs: {
      "disabled": _vm.status == 9,
      "placeholder": "请输入品牌英文名称"
    },
    model: {
      value: (_vm.addForm.brandEnname),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "brandEnname", $$v)
      },
      expression: "addForm.brandEnname"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "ml200 f999"
  }, [_vm._v("如果品牌没有中文名称或者英文名称，请在“中文名称”和“英文名称”输入相同的内容。")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "dib mt20",
    attrs: {
      "label": "品牌介绍：",
      "prop": "brandDesc"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "disabled": _vm.status == 9,
      "autosize": {
        minRows: 6,
        maxRows: 10
      },
      "type": "textarea",
      "placeholder": "入驻品牌的介绍，品牌商品的卖点",
      "maxlength": 200
    },
    model: {
      value: (_vm.addForm.brandDesc),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "brandDesc", $$v)
      },
      expression: "addForm.brandDesc"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "word_num"
  }, [_vm._v("您可以输入 "), _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.amount))]), _vm._v(" 个字")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "重点商品：",
      "prop": "brandGoodsDesc"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "disabled": _vm.status == 9,
      "autosize": {
        minRows: 6,
        maxRows: 10
      },
      "type": "textarea",
      "placeholder": "重点商品介绍及线上链接，建议三款商品左右"
    },
    model: {
      value: (_vm.addForm.brandGoodsDesc),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "brandGoodsDesc", $$v)
      },
      expression: "addForm.brandGoodsDesc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "200px"
    }
  }, [(_vm.status != 9) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.status == 9) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.status == 9,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save_add('addForm')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.noDialog,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.noDialog = $event
      }
    }
  }, [_c('span', [_vm._v("没有搜索到相关品牌，请[添加新品牌]")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.noDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b17c5da2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/edit/addBrand.vue
// module id = 566
// module chunks = 0